// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

html {
  font-size: 62.5%;
  height: 100%;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body {
  font-size: 1.4rem;
  background-color: #ffffff;
  overflow-x: hidden;
  height: 100%;
  font-family: "Roboto", sans-serif !important;
}

#root {
  height: 100%;
  background: #fcfcfc !important;
}

/* width */
::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 1px grey;
  border-radius: 0px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #dbdbdb;
  border-radius: 16px;
}

::-webkit-scrollbar-thumb:hover {
  background: #4d4d4d;
}

a {
  text-decoration: none;
}

@media screen and (max-width: 659px) {
  ::-webkit-scrollbar {
    width: 0px;
  }
}
a {
  text-decoration: none;
}

:root {
  --color-primary: #00a66e;
  --color-secondary: #ff6019;
  --color-secondary-light: #fed6d6;
  --color-error: #ff3636;
  --color-success: #31c274;
  --color-white: #fff;
  --color-disabled-hot: #545b7d;
  --color-grey: #6d7d8b;
}

.color-primary {
  color: #00a66e !important;
}

.color-secondary {
  color: #ff6019 !important;
}

.color-white {
  color: #ffffff !important;
}

.color-grey {
  color: #6d7d8b !important;
}

.bg-white {
  background-color: #fff !important;
}

.bg-primary {
  background-color: #00a66e !important;
}

.bg-secondary {
  background-color: #ff6019 !important;
}

.bg-light-secondary {
  background-color: var(--color-secondary-light) !important;
}

.bg-light-grey {
  background-color: #f9fafc !important;
}

.h-100 {
  height: 100%;
}

.w-100 {
  width: 100%;
}

.w-50 {
  width: 50%;
}

.d-flex {
  display: flex;
}

.align-center {
  align-items: center;
}

.space__bw {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.align-start {
  align-items: flex-start;
}

.justify-start {
  justify-content: flex-start;
}

.align-end {
  align-items: flex-end;
}

.flex-column {
  flex-direction: column;
}

.border-square {
  border-radius: 16px;
}

.p-relative {
  position: relative;
}

.MuiDataGrid-root .MuiDataGrid-columnHeader:focus,
.MuiDataGrid-root .MuiDataGrid-cell:focus {
  outline: none !important;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/index.scss"],"names":[],"mappings":"AAGA;EACE,sBAAA;EACA,SAAA;EACA,UAAA;AADF;;AAIA;EACE,gBAAA;EACA,YAAA;EACA,mCAAA;EACA,kCAAA;AADF;;AAIA;EACE,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,4CAAA;AADF;;AAGA;EACE,YAAA;EACA,8BAAA;AAAF;;AAGA,UAAA;AACA;EACE,UAAA;EACA,WAAA;AAAF;;AAGA,UAAA;AACA;EACE,8BAAA;EACA,kBAAA;AAAF;;AAGA,WAAA;AACA;EACE,mBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,qBAAA;AAAF;;AAGA;EACE;IACE,UAAA;EAAF;AACF;AAGA;EACE,qBAAA;AADF;;AAIA;EACE,wBAAA;EACA,0BAAA;EACA,gCAAA;EACA,sBAAA;EACA,wBAAA;EACA,mBAAA;EACA,6BAAA;EACA,qBAAA;AADF;;AAKA;EACE,yBAAA;AAFF;;AAIA;EACE,yBAAA;AADF;;AAGA;EACE,yBAAA;AAAF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,iCAAA;AACF;;AACA;EACE,oCAAA;AAEF;;AAAA;EACE,oCAAA;AAGF;;AADA;EACE,yDAAA;AAIF;;AAFA;EACE,oCAAA;AAKF;;AAHA;EACE,YAAA;AAMF;;AAJA;EACE,WAAA;AAOF;;AALA;EACE,UAAA;AAQF;;AANA;EACE,aAAA;AASF;;AAPA;EACE,mBAAA;AAUF;;AARA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AAWF;;AATA;EACE,uBAAA;AAYF;;AAVA;EACE,2BAAA;AAaF;;AAXA;EACE,qBAAA;AAcF;;AAZA;EACE,sBAAA;AAeF;;AAbA;EACE,mBAAA;AAgBF;;AAdA;EACE,kBAAA;AAiBF;;AAdA;;EAEE,wBAAA;AAiBF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap\");\r\n@import \"../mixins/variables.scss\";\r\n\r\n* {\r\n  box-sizing: border-box;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\nhtml {\r\n  font-size: 62.5%;\r\n  height: 100%;\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n}\r\n\r\nbody {\r\n  font-size: 1.4rem;\r\n  background-color: #ffffff;\r\n  overflow-x: hidden;\r\n  height: 100%;\r\n  font-family: \"Roboto\", sans-serif !important;\r\n}\r\n#root {\r\n  height: 100%;\r\n  background: #fcfcfc !important;\r\n}\r\n\r\n/* width */\r\n::-webkit-scrollbar {\r\n  width: 5px;\r\n  height: 5px;\r\n}\r\n\r\n/* Track */\r\n::-webkit-scrollbar-track {\r\n  box-shadow: inset 0 0 1px grey;\r\n  border-radius: 0px;\r\n}\r\n\r\n/* Handle */\r\n::-webkit-scrollbar-thumb {\r\n  background: #dbdbdb;\r\n  border-radius: 16px;\r\n}\r\n\r\n::-webkit-scrollbar-thumb:hover {\r\n  background: #4d4d4d;\r\n}\r\n\r\na {\r\n  text-decoration: none;\r\n}\r\n\r\n@media screen and (max-width: 659px) {\r\n  ::-webkit-scrollbar {\r\n    width: 0px;\r\n  }\r\n}\r\n\r\na {\r\n  text-decoration: none;\r\n}\r\n\r\n:root {\r\n  --color-primary: #{$color-primary};\r\n  --color-secondary: #{$color-secondary};\r\n  --color-secondary-light: #fed6d6;\r\n  --color-error: #{$color-error};\r\n  --color-success: #{$color-success};\r\n  --color-white: #{$color-white};\r\n  --color-disabled-hot: #{$color-disabled-hot};\r\n  --color-grey: #{$color-grey};\r\n}\r\n\r\n// colors\r\n.color-primary {\r\n  color: $color-primary !important;\r\n}\r\n.color-secondary {\r\n  color: $color-secondary !important;\r\n}\r\n.color-white {\r\n  color: #ffffff !important;\r\n}\r\n.color-grey {\r\n  color: #6d7d8b !important;\r\n}\r\n// background-colors\r\n.bg-white {\r\n  background-color: #fff !important;\r\n}\r\n.bg-primary {\r\n  background-color: $color-primary !important;\r\n}\r\n.bg-secondary {\r\n  background-color: $color-secondary !important;\r\n}\r\n.bg-light-secondary {\r\n  background-color: var(--color-secondary-light) !important;\r\n}\r\n.bg-light-grey {\r\n  background-color: #f9fafc !important;\r\n}\r\n.h-100 {\r\n  height: 100%;\r\n}\r\n.w-100 {\r\n  width: 100%;\r\n}\r\n.w-50 {\r\n  width: 50%;\r\n}\r\n.d-flex {\r\n  display: flex;\r\n}\r\n.align-center {\r\n  align-items: center;\r\n}\r\n.space__bw {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n.align-start {\r\n  align-items: flex-start;\r\n}\r\n.justify-start {\r\n  justify-content: flex-start;\r\n}\r\n.align-end {\r\n  align-items: flex-end;\r\n}\r\n.flex-column {\r\n  flex-direction: column;\r\n}\r\n.border-square {\r\n  border-radius: 16px;\r\n}\r\n.p-relative {\r\n  position: relative;\r\n}\r\n\r\n.MuiDataGrid-root .MuiDataGrid-columnHeader:focus,\r\n.MuiDataGrid-root .MuiDataGrid-cell:focus {\r\n  outline: none !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
